import { getDefaultPanelColors } from './get-default-panel-colors';

export function setDefaultItemBorder(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty('--itemBorder', getDefaultPanelColors().itemBorder);
}
